import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';
import { motion } from 'framer-motion';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <motion.button
            onClick={toggleTheme}
            className={`
        relative inline-flex items-center h-9 w-16 px-1 rounded-full transition-colors duration-300 focus:outline-none border
        ${isDark
                    ? 'bg-slate-800 border-slate-700 hover:bg-slate-700'
                    : 'bg-white border-slate-200 hover:bg-slate-50'
                }
      `}
            whileTap={{ scale: 0.95 }}
            aria-label="Toggle theme"
        >
            <motion.div
                className={`
          flex items-center justify-center w-7 h-7 rounded-full shadow-md transform transition-transform
          ${isDark ? 'bg-indigo-500' : 'bg-amber-400'}
        `}
                animate={{
                    x: isDark ? 28 : 0,
                    rotate: isDark ? 360 : 0
                }}
                transition={{ type: "spring", stiffness: 500, damping: 30 }}
            >
                <motion.div
                    initial={false}
                    animate={{ scale: isDark ? 1 : 0, opacity: isDark ? 1 : 0 }}
                    transition={{ duration: 0.2 }}
                    className="absolute"
                >
                    <Moon size={14} className="text-white" fill="currentColor" />
                </motion.div>
                <motion.div
                    initial={false}
                    animate={{ scale: isDark ? 0 : 1, opacity: isDark ? 0 : 1 }}
                    transition={{ duration: 0.2 }}
                    className="absolute"
                >
                    <Sun size={14} className="text-white" fill="currentColor" />
                </motion.div>
            </motion.div>

            {/* Background icons for visual cue */}
            <div className="absolute inset-0 flex justify-between items-center px-2 pointer-events-none">
                <Sun size={12} className={`transition-opacity duration-300 ${isDark ? 'opacity-0' : 'opacity-0'}`} /> {/* Hidden as handle covers */}
            </div>
        </motion.button>
    );
};

export default ThemeToggle;
